/**
 * like _cn(), but takes an *args of class-name Strings. drops any empty/falsey values and joins
 * together to produce the final `className` attribute value
 *
 * to do classes conditional on booleans, call in this form:
 * ```
 *  cn('always',
 *     expr && 'sometimes',
 *     mobile && 'mobile-class')
 * ```
 * :param arguments
 */
/* eslint-disable prefer-rest-params */
const cn = function cn() {
  const arr = []
  for (let i = 0, len = arguments.length; i < len; ++i) {
    if (arguments[i]) {
      arr.push(arguments[i])
    }
  }
  return arr.join(' ')
}

// eslint-disable-next-line import/no-default-export
export default cn
